/**
 * Report Summary Component
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Users, Clock, CheckCircle } from "lucide-react";

export const ReportSummary = ({ summary, dateRange }) => {
  if (!summary) return null;

  return (
    <Card className="bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-200">
      <CardHeader>
        <CardTitle className="text-xl text-blue-800 flex items-center gap-2">
          <Calendar className="w-5 h-5" />
          Report Summary
          <Badge className="ml-2 bg-blue-100 text-blue-800">
            {dateRange}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center gap-2 text-blue-600 mb-1">
              <Calendar className="w-4 h-4" />
              <span className="text-sm">Operating Days</span>
            </div>
            <p className="text-2xl font-bold text-blue-800">{summary.totalOperatingDays}</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center gap-2 text-blue-600 mb-1">
              <Users className="w-4 h-4" />
              <span className="text-sm">Total Children</span>
            </div>
            <p className="text-2xl font-bold text-blue-800">{summary.totalChildren}</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center gap-2 text-green-600 mb-1">
              <CheckCircle className="w-4 h-4" />
              <span className="text-sm">Avg Daily Attendance</span>
            </div>
            <p className="text-2xl font-bold text-green-700">{summary.avgDailyAttendance?.toFixed(1) || 0}</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center gap-2 text-blue-600 mb-1">
              <Clock className="w-4 h-4" />
              <span className="text-sm">Avg Hours/Child</span>
            </div>
            <p className="text-2xl font-bold text-blue-700">{summary.avgHoursPerChild?.toFixed(1) || 0}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReportSummary;
